require('./_wks-define')('observable');


//////////////////
// WEBPACK FOOTER
// /Users/luca/dev/lucagarbin/mascioni.it/~/core-js/modules/es7.symbol.observable.js
// module id = 314
// module chunks = 0